export enum DocumentEntityType {
    asset = 'asset',
    incomeEmployment = 'incomeEmployment',
    incomeOther = 'incomeOther',
    incomePension = 'incomePension',
    property = 'property'
}
